import React from 'react';

export default
    <g>
        <path className="circle" fill="currentColor" d="M6 0a6 6 0 1 0 .002 12.002A6 6 0 0 0 6 0z"/>
        <g className="icon" fill="#FFF">
            <path d="M6 2.661a1.016 1.016 0 1 1 0 2.033A1.016 1.016 0 0 1 6 2.66zM7.355 8.806c0 .16-.13.29-.29.29h-2.13a.29.29 0 0 1-.29-.29v-.58c0-.16.13-.29.29-.29h.29V6.386h-.29a.29.29 0 0 1-.29-.29v-.58c0-.161.13-.291.29-.291h1.549c.16 0 .29.13.29.29v2.42h.29c.16 0 .29.13.29.29v.58z"/>
        </g>
    </g>
